<template>
  <v-container>
    <v-card
      :loading="false"
    >
      <v-overlay
        :absolute="true"
        :value="isComponentLoading"
      >
        <v-progress-circular indeterminate size="24"></v-progress-circular>
      </v-overlay>
      <v-row class="pa-3">
        <v-col
                v-if="regionsItems"
                cols="12" md="4">
          <v-select
                  v-model="searchParams.region"
                  :hint="$t('hints.region')"
                  :items="regionsItems"
                  persistent-hint
                  single-line
                  :loading="false"
          ></v-select>
        </v-col>
        <v-col cols="12" md="8">
          <v-text-field
            v-model="searchParams.search_contact"
            :hint="$t('hints.searchByTitle')"
            persistent-hint
            single-line
            :loading="false"
          />
        </v-col>
      </v-row>
    </v-card>
  </v-container>
</template>

<script>
import searchTextFilter from '@/mixins/filters/searchTextFilter';
import regionsFilter from '@/mixins/filters/regionsFilter';
import isComponentLoading from '../../mixins/isComponentLoading';
/* components */

export default {
  name: 'FilterStock',
  mixins: [
    isComponentLoading,
    searchTextFilter,
    regionsFilter,
  ],
  components: {
  },
  props: {
    defaultSearchParams: {
      type: Object,
      default: () => ({
        search_contact: '',
        region: null,
      }),
    },
  },
  data() {
    return {
      searchParams: {},
    };
  },
  mounted() {
    this.searchParams = {
      search_contact: this.defaultSearchParams.search_contact,
      region: this.defaultSearchParams.region,
    };
  },
  computed: {
    account() {
      return this.$store.getters['account/account'];
    },
  },
  watch: {
    searchParams: {
      handler(newVal) {
        this.$emit('filtering', newVal);
      },
      deep: true,
    },
  },
  methods: {

  },
};
</script>

<style scoped>

</style>
